import React, { FC, ReactNode, useEffect, useState, useCallback } from "react";
import {
  Input,
  Button,
  Row,
  Col,
  Checkbox,
  DatePicker,
  TimePicker,
  Slider,
  Progress,
} from "antd";
import _ from "lodash";
import { DownOutlined } from "@ant-design/icons";
import { QuestionaireType } from "../../../constants/enums";
import NumberInput from "../../../common/NumberInput";
import CurrencyInput from "../../../common/CurrencyInput";
import TagInput from "../../../common/TagInput";
import MapInput from "../../../common/MapInput";
import EmailInput from "../../../common/EmailInput";
import FileUpload from "../../../common/FileUpload";
import "antd/dist/antd.css";
import moment from "moment";
import { ReactSVG } from "react-svg";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

const { TextArea } = Input;

declare var JSBridge: any;

const AnswerModel: FC<{
  data: any;
  moveNext: any;
  moveBack: any;
  count: number;
  totalQuestions: number;
  onClose: any;
}> = ({ data, moveNext, moveBack, count, totalQuestions, onClose }) => {
  const [mChoice, setMchoice] = useState("");
  const [description, setDescription] = useState<any>(data.value);
  const [firstName, setFirstName] = useState<string>("");
  const [middleName, setMiddleName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [phone, setPhone] = useState<any>(data.value || []);
  const [date, setDate] = useState<any>(data.value || null);
  const [location, setlocation] = useState<any>(data.value || null);
  const [answer, setAnswer] = useState<any>(data.value || null);
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [eventFromNative, setEventFromNative] = useState<any>();

  useEffect(() => {
    switch (data.type) {
      case QuestionaireType.Name:
        const name = data?.value?.split(" ");
        setFirstName(name?.[0] || "");
        setMiddleName(name?.[1] || "");
        setLastName(name?.[2] || "");
        break;
      case QuestionaireType.Phone:
        setPhone(data.value);
        break;
      case QuestionaireType.Text:
        setDescription(data.value);
        break;
      case QuestionaireType.MultipleChoice:
        setMchoice(data.value);
        break;
      case QuestionaireType.Time:
      case QuestionaireType.DateTime:
        setDate(data.value ? data.value : null);
        break;
      default:
        break;
    }
    setAnswer(data.value || null);
    setIsMobile(/iPhone|iPad|iPod|Android/i.test(navigator.userAgent));
    window.addEventListener("nativeEvent", customEventHandler);
    return () => window.removeEventListener("nativeEvent", customEventHandler);
  }, [data]);

  const customEventHandler = useCallback(
    (e) => {
      const response = JSON.parse(e.detail);
      setEventFromNative(response);
    },
    [setEventFromNative]
  );

  useEffect(() => {
    if(eventFromNative){
      if (eventFromNative.type === "media") {
        setAnswer({
          name: eventFromNative.attributes.body,
          url: eventFromNative.attributes.urls.original.url,
          ...eventFromNative.attributes,
        });
      }
      if (eventFromNative.type === "place") {
        const ans = {
          lat: eventFromNative.attributes.coordinates.lat,
          lng: eventFromNative.attributes.coordinates.long
        }
        setAnswer(ans);
        setlocation(ans);
      }
    }
  }, [eventFromNative]);

  let renderEle: ReactNode = "";

  const sliderIndicatorStyle = {
    marginLeft: 10,
    fontSize: "medium",
  };

  switch (data.type) {
    case QuestionaireType.ThreeButton:
      renderEle = (
        <Row className="mt-3">
          <Col span={24}>
            <Row className="d-flex mb-4">
              <Col span={12} className="pr-2">
                <Button
                  className={
                    answer === "yes"
                      ? "beam-btn green-btn cover w-full btn-selected"
                      : "beam-btn green-btn cover w-full"
                  }
                  onClick={() => setAnswer("yes")}
                >
                  Yes
                </Button>
              </Col>
              <Col span={12} className="pl-2">
                <Button
                  className={
                    answer === "maybe"
                      ? "beam-btn w-full btn-selected"
                      : "beam-btn w-full"
                  }
                  onClick={() => setAnswer("maybe")}
                >
                  Maybe
                </Button>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Button
                  className={
                    answer === "no"
                      ? "beam-btn orange-btn cover w-full btn-selected"
                      : "beam-btn orange-btn cover w-full"
                  }
                  onClick={() => setAnswer("no")}
                >
                  No
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      );
      break;
    case QuestionaireType.YesNo:
      renderEle = (
        <Row className="mt-3">
          <Col span={24}>
            <Row className="d-flex">
              <Col span={12} className="pr-2">
                <Button
                  className={
                    answer === "yes"
                      ? "beam-btn green-btn cover w-full btn-selected"
                      : "beam-btn green-btn cover w-full"
                  }
                  onClick={() => setAnswer("yes")}
                >
                  Yes
                </Button>
              </Col>
              <Col span={12} className="pl-2">
                <Button
                  className={
                    answer === "no"
                      ? "beam-btn orange-btn cover w-full btn-selected"
                      : "beam-btn orange-btn cover w-full"
                  }
                  key="yes-no"
                  onClick={() => setAnswer("no")}
                >
                  No
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      );
      break;
    case QuestionaireType.MultipleChoice:
      renderEle = data.multi ? (
        <Row className="mt-3 custom-checkbox-group">
          <Col span={24}>
            <Checkbox.Group
              className="d-block"
              options={data.options}
              defaultValue={[]}
              onChange={(values) => setAnswer(values)}
            />
          </Col>
        </Row>
      ) : (
        <Row className="d-block mt-3">
          {data.options.map((value, index) => (
            <Checkbox
              className="mb-2 ml-0"
              checked={mChoice === value}
              name={value}
              key={value}
              value={data.options[index]}
              onChange={(e) => {
                setAnswer(e.target.value);
                setMchoice(e.target.value);
              }}
            >
              {value}
            </Checkbox>
          ))}
        </Row>
      );
      break;
    case QuestionaireType.Bar:
      renderEle = (
        <Row className="d-flex justify-content-center custom-slider-survey mt-5">
          <Col span={24}>
            <Slider
              marks={{
                [data.options[1]]: {
                  style: sliderIndicatorStyle,
                  label: <strong>{data.options[1]}</strong>,
                },
                [data.options[0]]: {
                  style: sliderIndicatorStyle,
                  label: <strong>{data.options[0]}</strong>,
                },
              }}
              defaultValue={data.value}
              max={data.options[0]}
              min={data.options[1]}
              step={data.options[2]}
              onChange={(value) => {
                setAnswer(value);
              }}
            />
          </Col>
        </Row>
      );
      break;
    case QuestionaireType.Date:
      renderEle = (
        <Row className="mt-3">
          <Col span={24}>
            <Calendar
              className="custom-calendar"
              onChange={(date) => {
                setAnswer(new Date(date));
              }}
              value={new Date(data.value)}
            />
          </Col>
        </Row>
      );
      break;
    case QuestionaireType.Number:
      renderEle = (
        <Row className="mt-3">
          <NumberInput
            value={data.value}
            onChange={(num) => {
              setAnswer(num);
            }}
          />
        </Row>
      );
      break;
    case QuestionaireType.Text:
      renderEle = (
        <Row className="mt-3">
          <TextArea
            autoSize={{ minRows: 3, maxRows: 5 }}
            placeholder="Type here..."
            value={description}
            onChange={(e) => {
              setDescription(e.target.value);
              setAnswer(e.target.value);
            }}
          />
        </Row>
      );
      break;
    case QuestionaireType.Name:
      renderEle = (
        <Row className="mt-3">
          <Input
            className="w-full"
            value={firstName}
            placeholder="First name"
            onChange={(e) => {
              const fullName =
                e.target.value + " " + middleName + " " + lastName;
              setAnswer(fullName);
              setFirstName(e.target.value);
            }}
          />
          <Input
            className="w-full mt-2"
            value={middleName}
            placeholder="Middle name"
            onChange={(e) => {
              const fullName =
                firstName + " " + e.target.value + " " + lastName;
              setAnswer(fullName);
              setMiddleName(e.target.value);
            }}
          />
          <Input
            className="w-full mt-2"
            value={lastName}
            placeholder="Last name"
            onChange={(e) => {
              const fullName =
                firstName + " " + middleName + " " + e.target.value;
              setAnswer(fullName);
              setLastName(e.target.value);
            }}
          />
        </Row>
      );
      break;
    case QuestionaireType.Time:
      renderEle = (
        <Row className="datetime-item mt-3">
          <TimePicker
            placeholder="Select Time"
            suffixIcon={<DownOutlined />}
            value={date}
            onChange={(time: moment.Moment | null) => {
              setDate(time);
              setAnswer(time);
            }}
          />
        </Row>
      );
      break;
    case QuestionaireType.DateTime:
      renderEle = (
        <Row className=" w-full mt-3">
          <div className="datetime-item">
            <img src="/images/date.png" alt="" />
            <DatePicker
              showTime
              placeholder="Select Date"
              suffixIcon={<DownOutlined />}
              value={moment(data.value)}
              onChange={(datetime: moment.Moment | null) => {
                setDate(datetime);
                setAnswer(datetime);
              }}
            />
          </div>
        </Row>
      );
      break;
    case QuestionaireType.Currency:
      renderEle = (
        <Row className="mt-3">
          <CurrencyInput
            value={0}
            suffix={data.options[0]}
            onChange={(num) => {
              setAnswer(num);
            }}
          />
        </Row>
      );
      break;
    case QuestionaireType.Location:
      renderEle = (
        <Row className="custom-map mt-3">
          <Col span={24}>
            <div className="custom-map-title" onClick={()=>{
              if(isMobile){
                const request = { type: "surveyGps" };
                window?.webkit?.messageHandlers?.jsMessageHandler.postMessage(
                  JSON.stringify(request)
                );
                try {
                  JSBridge?.jsMessageHandler(JSON.stringify(request));
                } catch (e) {
                  console.log("js bridge does not exist");
                }
              }
            }}>
              <ReactSVG src="/images/notification-icon.svg" />
              <p>{isMobile ? "Click to get posiiton": "Drop your position"}</p>
            </div>
            <MapInput
              value={location}
              isMobile={isMobile}
              onChange={(loc, address) => {
                setlocation(loc);
                setAnswer(loc);
              }}
            />
          </Col>
        </Row>
      );
      break;
    case QuestionaireType.GPS:
      renderEle = (
        <Row className="custom-map mt-3">
          <Col span={24}>
          <div className="custom-map-title" onClick={()=>{
              if(isMobile){
                const request = { type: "surveyGps" };
                window?.webkit?.messageHandlers?.jsMessageHandler.postMessage(
                  JSON.stringify(request)
                );
                try {
                  JSBridge?.jsMessageHandler(JSON.stringify(request));
                } catch (e) {
                  console.log("js bridge does not exist");
                }
              }
            }}>
              <ReactSVG src="/images/notification-icon.svg" />
              <p>{isMobile ? "Click to get posiiton": "Drop your position"}</p>
            </div>
            <MapInput
              value={location}
              onChange={(loc) => {
                setAnswer(loc);
              }}
              isMobile={isMobile}
            />
          </Col>
        </Row>
      );
      break;
    case QuestionaireType.File:
      renderEle = (
        <Row className="mt-3">
          <FileUpload
            value={answer}
            isMobile={isMobile}
            onUploadClick={() => {
              const request = { type: "surveyImage" };
              window?.webkit?.messageHandlers?.jsMessageHandler.postMessage(
                JSON.stringify(request)
              );
              try {
                JSBridge?.jsMessageHandler(JSON.stringify(request));
              } catch (e) {
                console.log("js bridge does not exist");
              }
            }}
            onChange={(file) => {
              setAnswer(file);
            }}
          />
        </Row>
      );
      break;
    case QuestionaireType.Signature:
      renderEle = (
        <Row className="mt-3">
          <FileUpload
            value={answer}
            isMobile={isMobile}
            onUploadClick={() => {
              const request = { type: "surveySignature" };
              window?.webkit?.messageHandlers?.jsMessageHandler.postMessage(
                JSON.stringify(request)
              );
              try {
                JSBridge?.jsMessageHandler(JSON.stringify(request));
              } catch (e) {
                console.log("js bridge does not exist");
              }
            }}
            onChange={(sign) => {
              setAnswer(sign);
            }}
          />
        </Row>
      );
      break;
    case QuestionaireType.Media:
      renderEle = (
        <Row className="mt-3">
          <FileUpload
            value={answer}
            isMobile={isMobile}
            onUploadClick={() => {
              const request = { type: "surveyImage" };
              window?.webkit?.messageHandlers?.jsMessageHandler.postMessage(
                JSON.stringify(request)
              );
              try {
                JSBridge?.jsMessageHandler(JSON.stringify(request));
              } catch (e) {
                console.log("js bridge does not exist");
              }
            }}
            onChange={(media) => {
              setAnswer(media);
            }}
          />
        </Row>
      );
      break;
    case QuestionaireType.Phone:
      renderEle = (
        <Row className="mt-3 d-flex">
          <Col span={7}>
            <Input
              className="w-full"
              placeholder="country code"
              value={phone[0]}
              onChange={(e) => {
                const phoneNumber = [e.target.value, phone[1]];
                setPhone(phoneNumber);
                setAnswer(phoneNumber);
              }}
            />
          </Col>
          <Col span={16}>
            <Input
              className="w-full"
              placeholder="phone number"
              value={phone[1]}
              onChange={(e) => {
                const phoneNumber = [phone[0], e.target.value];
                setPhone(phoneNumber);
                setAnswer(phoneNumber);
              }}
            />
          </Col>
        </Row>
      );
      break;
    case QuestionaireType.Email:
      renderEle = (
        <div className="mt-3">
          <EmailInput
            value={data.value}
            onChange={(email) => {
              setAnswer(email);
            }}
          />
        </div>
      );
      break;
    case QuestionaireType.Tag:
      renderEle = (
        <div className="mt-3">
          <TagInput
            value={data.value}
            onChange={(tags: string[]) => {
              setAnswer(data.value);
            }}
          />
        </div>
      );
      break;
    case QuestionaireType.TagNot:
      renderEle = (
        <div className="mt-3">
          <TagInput
            value={data.value}
            onChange={(tags: string[]) => {
              setAnswer(tags);
            }}
          />
        </div>
      );
      break;
    default:
      renderEle = "";
  }

  return (
    <div>
      <Row className="d-flex">
        <Col>
          <h4>Project ID: {eventFromNative?.type}</h4>
        </Col>
        <Col>
          <h4>Question: 1</h4>
        </Col>
        {/* make cross icon functional */}
        <Col>
          <a onClick={() => onClose()}>X</a>
        </Col>
      </Row>
      <hr />

      <Col span={24} className="mt-4">
        <Progress
          className="custom-progress"
          percent={(count / totalQuestions) * 100}
          strokeWidth={12}
          strokeColor="#40CC52"
          format={() => {
            return `Answered: ${count}/${totalQuestions}`;
          }}
        />
      </Col>

      <Row className="mb-3 mt-4">
        <Col span={24}>
          <p className="t-question">{data.label}</p>
        </Col>
      </Row>

      <Row className="tiles">
        <Col span={24}>
          <Row>
            <Col className="mb-2">
              <h4>Answer: </h4>
            </Col>
          </Row>
          {renderEle}
        </Col>
      </Row>

      <hr className="mt-4 mb-4" />
      <Row className="d-flex mt-4">
        <Col span={11} className="pl-2">
          <Button
            className="beam-btn orange-btn bordered w-full"
            onClick={moveBack}
          >
            Back
          </Button>
        </Col>
        <Col span={11} className="pr-2">
          <Button
            className="beam-btn green-btn cover w-full"
            onClick={() => moveNext(answer)}
          >
            Submit
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default AnswerModel;
